import { Chip } from "@mui/material";
import { pascalCase } from "../../utils/textUtils";

interface RecordStatusColor {
  main: string;
  bg: string;
}

const statusColors: Record<string, RecordStatusColor> = {
  needs_response: { main: '#F4C67A', bg: '#FFF8E5' },
  waiting_for_seller_response: { main: '#F4C67A', bg: '#FFF8E5' },
  undefended: { main: '#F4C67A', bg: '#FFF8E5' }, // adyen
  unresponded: { main: '#F4C67A', bg: '#FFF8E5' }, // adyen

  under_review: { main: '#A293F1', bg: '#F7F4FF' },
  waiting_for_buyer_response: { main: '#A293F1', bg: '#F7F4FF' },
  pending: { main: '#A293F1', bg: '#F7F4FF' }, // adyen
  responded: { main: '#A293F1', bg: '#F7F4FF' }, // adyen

  open: { main: '#6366F1', bg: '#EEF0FF' },
  in_progress: { main: '#5CA9F0', bg: '#EAF6FF' },
  won: { main: '#58C492', bg: '#EAFBF3' },
  cancelled: { main: '#58C492', bg: '#EAFBF3' },

  lost: { main: '#E57373', bg: '#FFF1F1' },
  refunded: { main: '#E57373', bg: '#FFF1F1' },
  partially_refunded: { main: '#E57373', bg: '#FFF1F1' },
  accepted: { main: '#E57373', bg: '#FFF1F1' },
  appealable: { main: '#E57373', bg: '#FFF1F1' },
  expired: { main: '#E57373', bg: '#FFF1F1' }, // adyen

  closed: { main: '#9AA4B2', bg: '#F3F4F6' },
  unknown: { main: '#9AA4B2', bg: '#F3F4F6' },
  unfightable: { main: '#9AA4B2', bg: '#F3F4F6' },
};

export default function DisputeStatusChip({ status }: { status: string }) {
  const normalisedStatus = status.replace('warning_', '').toLowerCase();
  return <Chip
    label={pascalCase(normalisedStatus)}
    sx={{
      backgroundColor: statusColors[normalisedStatus]?.bg,
      color: statusColors[normalisedStatus]?.main,
      fontWeight: 500,
      borderRadius: '10px',
      backdropFilter: 'blur(8px)', // Apple-style glassiness
    }}
  />;
}
